function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import EBPropTypes from 'js-utils/prop-types';
import { CROP_THUMB_DIRECTIONS, DIRECTION_TO_CLASSNAME_MAP, CROP_MASK_PROP_TYPE } from './constants';
import { formatPercentCropMaskForPolygon, formatPercentCropMaskForSVG, formatPercentCropMaskForStyle, constrainCropMask, cropMaskToPercent, getDefaultCropMask, getScale, addMoveListener, addActionEndListener, removeMoveListener, removeActionEndListener, getNextMovedCropMask, getNextResizedCropMask, shouldUpdateCropMask, cropMaskDidChange } from './utils';
import { getEventPosition } from '../utils/events';

var ImageCropperMask = function ImageCropperMask(_ref) {
  var percentCropMask = _ref.percentCropMask;

  if (!percentCropMask) {
    return null;
  }

  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "eds-image-cropper__cover",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, React.createElement("polygon", {
    className: "eds-image-cropper__mask",
    points: formatPercentCropMaskForPolygon(percentCropMask)
  }), React.createElement("rect", _extends({
    className: "eds-image-cropper__ants",
    vectorEffect: "non-scaling-stroke"
  }, formatPercentCropMaskForSVG(percentCropMask))));
};

var ImageCropperPorthole = function ImageCropperPorthole(_ref2) {
  var percentCropMask = _ref2.percentCropMask,
      thumbMouseDown = _ref2.thumbMouseDown,
      portholeMouseDown = _ref2.portholeMouseDown;

  if (!percentCropMask) {
    return null;
  }

  var _handleThumbMouseDown = function _handleThumbMouseDown(direction, event) {
    // preventDefault to stop text-selection while dragging
    event.preventDefault();
    thumbMouseDown(getEventPosition(event), direction);
  };

  var _handlePortholeMouseDown = function _handlePortholeMouseDown(event) {
    // if the mousedown occurred on a resize thumb, ignore it
    // do this using data attr rather than stopPropagation
    if (event.target.getAttribute('data-cropper-thumb')) {
      return;
    }

    event.preventDefault();
    portholeMouseDown(getEventPosition(event));
  }; // TODO EB-57935: We need to make the ImageCropper accessible by providing keyboard support.
  // It currently only works with mouse/touch

  /* eslint-disable jsx-a11y/no-static-element-interactions */


  var thumbs = CROP_THUMB_DIRECTIONS.map(function (direction) {
    return React.createElement("div", {
      key: direction,
      className: "eds-image-cropper__thumb ".concat(DIRECTION_TO_CLASSNAME_MAP[direction]),
      "data-cropper-thumb": "true",
      onMouseDown: _handleThumbMouseDown.bind(undefined, direction),
      onTouchStart: _handleThumbMouseDown.bind(undefined, direction)
    });
  });
  return React.createElement("div", {
    className: "eds-image-cropper__porthole",
    style: formatPercentCropMaskForStyle(percentCropMask),
    onMouseDown: _handlePortholeMouseDown,
    onTouchStart: _handlePortholeMouseDown
  }, thumbs);
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

var ImageCropper =
/*#__PURE__*/
function (_Component) {
  _inherits(ImageCropper, _Component);

  function ImageCropper(props, context) {
    var _this;

    _classCallCheck(this, ImageCropper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageCropper).call(this, props, context)); // store references to bound handlers so they can be removed

    _defineProperty(_assertThisInitialized(_this), "state", {
      naturalWidth: 0,
      naturalHeight: 0,
      cropMask: undefined
    });

    _this._boundHandlePortholeMouseMove = _this._handlePortholeMouseMove.bind(_assertThisInitialized(_this));
    _this._boundHandlePortholeMouseUp = _this._handlePortholeMouseUp.bind(_assertThisInitialized(_this));
    _this._boundHandleThumbMouseMove = _this._handleThumbMouseMove.bind(_assertThisInitialized(_this));
    _this._boundHandleThumbMouseUp = _this._handleThumbMouseUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageCropper, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$state = this.state,
          naturalWidth = _this$state.naturalWidth,
          naturalHeight = _this$state.naturalHeight;
      var cropMask = this.state.cropMask;
      var isImageLoaded = !!(naturalWidth && naturalHeight);
      var nextCropMask = nextProps.cropMask;
      var shouldUpdate = shouldUpdateCropMask(nextProps, this.props);

      if (nextCropMask && cropMaskDidChange(nextCropMask, this.props.cropMask)) {
        cropMask = nextCropMask;
      }

      if (cropMask && isImageLoaded && shouldUpdate) {
        var aspectRatio = nextProps.aspectRatio,
            aspectRatioMaxChunkSize = nextProps.aspectRatioMaxChunkSize,
            onCropChanging = nextProps.onCropChanging,
            onCropDone = nextProps.onCropDone;
        cropMask = constrainCropMask(naturalWidth, naturalHeight, cropMask, aspectRatio, aspectRatioMaxChunkSize);

        this._finishCrop(cropMask, onCropChanging, onCropDone);
      }
    }
    /**
     * Finalize crop actions.  Accept onCropChanging & onCropDone as params so
     * they may be passed from componentWillReceiveProps nextProps rather
     * than existing props.
     */

  }, {
    key: "_finishCrop",
    value: function _finishCrop(cropMask, onCropChangingParam, onCropDoneParam) {
      var onCropChanging = onCropChangingParam || this.props.onCropChanging;
      var onCropDone = onCropDoneParam || this.props.onCropDone;
      this.setState({
        cropMask: cropMask
      });
      onCropChanging(cropMask);
      onCropDone(cropMask);
    }
  }, {
    key: "_setImageRef",
    value: function _setImageRef(ref) {
      this._image = ref;
    }
  }, {
    key: "_handleImageLoaded",
    value: function _handleImageLoaded() {
      var _this$props = this.props,
          aspectRatio = _this$props.aspectRatio,
          aspectRatioMaxChunkSize = _this$props.aspectRatioMaxChunkSize;
      var cropMask = this.props.cropMask;
      var _this$_image = this._image,
          naturalWidth = _this$_image.naturalWidth,
          naturalHeight = _this$_image.naturalHeight;

      if (!cropMask) {
        cropMask = getDefaultCropMask(naturalWidth, naturalHeight, aspectRatio, aspectRatioMaxChunkSize);
      }

      cropMask = constrainCropMask(naturalWidth, naturalHeight, cropMask, aspectRatio, aspectRatioMaxChunkSize);
      this.setState({
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight
      });

      this._finishCrop(cropMask);
    }
  }, {
    key: "_getScale",
    value: function _getScale() {
      var scale = 1; // sometimes scale is requested before image loads

      if (this._image && this._image.naturalWidth) {
        var _this$_image2 = this._image,
            clientWidth = _this$_image2.clientWidth,
            naturalWidth = _this$_image2.naturalWidth;
        scale = getScale(clientWidth, naturalWidth);
      }

      return scale;
    }
  }, {
    key: "_handlePortholeMouseDown",
    value: function _handlePortholeMouseDown(dragStartPosition) {
      var cropMask = this.state.cropMask;
      this._portholeMoveContext = {
        dragStartPosition: dragStartPosition,
        cropMask: cropMask
      };
      addMoveListener(this._boundHandlePortholeMouseMove);
      addActionEndListener(this._boundHandlePortholeMouseUp);
    }
  }, {
    key: "_handlePortholeMouseMove",
    value: function _handlePortholeMouseMove(event) {
      event.preventDefault();
      var _this$_portholeMoveCo = this._portholeMoveContext,
          dragStartPosition = _this$_portholeMoveCo.dragStartPosition,
          dragStartCrop = _this$_portholeMoveCo.cropMask;
      var onCropChanging = this.props.onCropChanging;
      var _this$state2 = this.state,
          naturalWidth = _this$state2.naturalWidth,
          naturalHeight = _this$state2.naturalHeight;

      var scale = this._getScale();

      var cropMask = getNextMovedCropMask(dragStartPosition, dragStartCrop, getEventPosition(event), scale, naturalWidth, naturalHeight);
      this.setState({
        cropMask: cropMask
      });
      onCropChanging(cropMask);
    }
  }, {
    key: "_handlePortholeMouseUp",
    value: function _handlePortholeMouseUp(event) {
      event.preventDefault();
      removeMoveListener(this._boundHandlePortholeMouseMove);
      removeActionEndListener(this._boundHandlePortholeMouseUp);
      delete this._portholeMoveContext;
      var cropMask = this.state.cropMask;

      this._finishCrop(cropMask);
    }
  }, {
    key: "_handleThumbMouseDown",
    value: function _handleThumbMouseDown(dragStartPosition, direction) {
      var cropMask = this.state.cropMask;
      this._handleMoveContext = {
        dragStartPosition: dragStartPosition,
        cropMask: cropMask,
        direction: direction
      };
      addMoveListener(this._boundHandleThumbMouseMove);
      addActionEndListener(this._boundHandleThumbMouseUp);
    }
  }, {
    key: "_handleThumbMouseMove",
    value: function _handleThumbMouseMove(event) {
      event.preventDefault();
      var _this$_handleMoveCont = this._handleMoveContext,
          dragStartPosition = _this$_handleMoveCont.dragStartPosition,
          dragStartCrop = _this$_handleMoveCont.cropMask,
          direction = _this$_handleMoveCont.direction;
      var _this$props2 = this.props,
          aspectRatio = _this$props2.aspectRatio,
          onCropChanging = _this$props2.onCropChanging,
          aspectRatioMaxChunkSize = _this$props2.aspectRatioMaxChunkSize;
      var _this$state3 = this.state,
          naturalWidth = _this$state3.naturalWidth,
          naturalHeight = _this$state3.naturalHeight;
      var cropMask = getNextResizedCropMask(direction, dragStartPosition, dragStartCrop, getEventPosition(event), naturalWidth, naturalHeight, this._getScale(), aspectRatio, aspectRatioMaxChunkSize);
      this.setState({
        cropMask: cropMask
      });
      onCropChanging(cropMask);
    }
  }, {
    key: "_handleThumbMouseUp",
    value: function _handleThumbMouseUp(event) {
      event.preventDefault();
      removeMoveListener(this._boundHandleThumbMouseMove);
      removeActionEndListener(this._boundHandleThumbMouseUp);
      delete this._handleMoveContext;
      var cropMask = this.state.cropMask;

      this._finishCrop(cropMask);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          imageSrc = _this$props3.imageSrc,
          imageCrossOrigin = _this$props3.imageCrossOrigin,
          imageAltText = _this$props3.imageAltText;
      var _this$state4 = this.state,
          naturalWidth = _this$state4.naturalWidth,
          naturalHeight = _this$state4.naturalHeight,
          cropMask = _this$state4.cropMask;
      var percentCropMask = null;

      if (naturalWidth && naturalHeight && cropMask) {
        percentCropMask = cropMaskToPercent(naturalHeight, naturalWidth, cropMask);
      }

      return React.createElement("div", {
        className: "eds-image-cropper"
      }, React.createElement(ImageCropperMask, {
        percentCropMask: percentCropMask
      }), React.createElement(ImageCropperPorthole, {
        percentCropMask: percentCropMask,
        thumbMouseDown: this._handleThumbMouseDown.bind(this),
        portholeMouseDown: this._handlePortholeMouseDown.bind(this)
      }), React.createElement("img", {
        src: imageSrc,
        alt: imageAltText,
        className: "eds-image-cropper__image",
        crossOrigin: imageCrossOrigin,
        ref: this._setImageRef.bind(this),
        onLoad: this._handleImageLoaded.bind(this)
      }));
    }
  }]);

  return ImageCropper;
}(Component);

_defineProperty(ImageCropper, "propTypes", {
  /**
   * imageSrc is passed as the src attribute of the image to be cropped.
   * This should be a valid image URL.
   */
  imageSrc: PropTypes.string.isRequired,

  /**
   * The callback function that will be invoked when the user
   * finishes changing the crop mask.
   */
  onCropDone: PropTypes.func,

  /**
   * The callback function that will be invoked while the user
   * is dragging or resizing the crop mask.
   */
  onCropChanging: PropTypes.func,

  /**
   * Use this to populate a crop mask.  Useful when editing an existing mask.
   */
  cropMask: CROP_MASK_PROP_TYPE,

  /**
   * imageCrossOrigin is passed as the crossOrigin attribute of the
   * underlying image tag.
   */
  imageCrossOrigin: PropTypes.string,

  /**
   * Alt attribute provided to the underlying image tag.
   */
  imageAltText: EBPropTypes.translation,

  /**
   * Desired aspect ratio of the resulting crop.
   */
  aspectRatio: PropTypes.number,

  /**
   * Certain aspect ratios are impossible to enforce exactly when using integers.
   * ImageCropper will attempt to fix inexact mask ratios by subtracting pixels from
   * the user-defined mask, up to a maximum subtraction threshold.  Use this prop
   * to define that treshhold.  For example, if using 2/1 aspect ratio, you can
   * set aspectRatioMaxChunkSize to 1 to allow subtraction of 1 pixel to fix
   * inexact results.  If using 3/1, set aspectRatioMaxChunkSize to 2.
   */
  aspectRatioMaxChunkSize: PropTypes.number
});

_defineProperty(ImageCropper, "defaultProps", {
  onCropDone: noop,
  onCropChanging: noop,
  imageAltText: '',
  aspectRatioMaxChunkSize: 10
});

export { ImageCropper as default };